import { Card, CardContent } from '@/components/ui/card';
import filterIcon from '@/v2/assets/images/select-filter-icon.png';
export default function SelectFilterInfoCard() {
  return (
    <Card className="border border-blue-200 shadow-sm rounded-2xl bg-blue-50">
      <CardContent className="p-6 flex flex-col h-full">
        <h2 className="text-2xl font-bold text-blue-900 leading-snug mb-4">
          Norėdami pradėti, <br />
          pasirinkite bent <br />
          vieną filtrą.
        </h2>

        {/* Icon bottom-right with some padding */}
        <div className="mt-auto flex justify-end pr-12 ">
          <img
            src={filterIcon}
            alt="Pasirinkite filtrą"
            className="w-22 sm:w-28 md:w-28 object-contain"
          />
        </div>
      </CardContent>
    </Card>
  );
}
